import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {AuthGuardService} from '../../../guards/auth-guard.service';
import {SelectTopicsComponent} from './select-topics.component';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.selectTopics.pageInRouting,
    data: {data: PAGES_AND_PATHS.selectTopics},
    component: SelectTopicsComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./select-topics.module').then(m => m.SelectTopicsModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SelectTopicsRoutingModule { }
